export const TAB_STATES = {
  GLOBAL_TIMELINES: 'GLOBAL_TIMELINES',
  NEW_FULFILLMENT_TIMELINES_V2: 'NEW_FULFILLMENT_TIMELINES_V2',
  RFI_TIMELINES: 'RFI_TIMELINES',
  PAYMENT_TIMELINES: 'PAYMENT_TIMELINES',
  FULFILLMENT_TIMELINES: 'FULFILLMENT_TIMELINES',
};

export const SETTLEMENT_TIMELINE_MANAGER_STRINGS = {
  HEADING: 'Settlement Timeline Manager',
  STRING_CONSTANTS: {
    [TAB_STATES.GLOBAL_TIMELINES] : {
      HEADING: 'Global Timelines',
      TABLE_HEADING: 'Global Timelines Configuration Table',
      ADD_A_NEW_CONFIG: 'Add a New Config',
      NO_GLOBAL_TIMELINES_FOUND: 'No Global Timelines Found!',
      INPUT_MODAL_TITLE: 'Add a New Global Settlement Timeline'
    },
    [TAB_STATES.RFI_TIMELINES] : {
      HEADING: 'RFI Timelines',
      TABLE_HEADING: 'RFI Timelines Configuration Table',
      ADD_A_NEW_CONFIG: 'Add a New Config',
      NO_RFI_TIMELINES_FOUND: 'No RFI Timelines Found!',
      INPUT_MODAL_TITLE: 'Add a New RFI Settlement Timeline'

    },
    [TAB_STATES.FULFILLMENT_TIMELINES] : {
      HEADING: 'Fulfillment Timelines (Deprecated)',
      TABLE_HEADING: 'Fulfillment Timelines Configuration Table',
      ADD_A_NEW_CONFIG: 'Add a New Config',
      NO_FULFILLMENT_TIMELINES_FOUND: 'No Fulfillment Timelines Found!',
      INPUT_MODAL_TITLE: 'Add a New Fulfillment Settlement Timeline'

    },
    [TAB_STATES.PAYMENT_TIMELINES] : {
      HEADING: 'Payment Timelines',
      TABLE_HEADING: 'Payment Timelines Configuration Table',
      ADD_A_NEW_CONFIG: 'Add a New Config',
      NO_PAYMENT_TIMELINES_FOUND: 'No Payment Timelines Found!',
      INPUT_MODAL_TITLE: 'Add a New Payment Settlement Timeline'

    },
    [TAB_STATES.NEW_FULFILLMENT_TIMELINES_V2] : {
      HEADING: 'New Fulfillment Timelines',
      NO_DATA_FOUND: 'No Fulfillment Timeline Configuration Found!',
      CONFIRM_UPDATE_TITLE: 'Confirm Update',
      CONFIRM_UPDATE_MESSAGE: 'Are you sure you want to update the Fulfillment Timeline Configuration?'
    }
  }
}
